import { isEmpty, partition } from 'lodash';

import { MedicalInformationAttachment } from '@dreryk/egabinet-patient-medical-information-frontend-api';
import { PatientConsentDocumentAttachment } from '@dreryk/egabinet-patient-frontend-api';

const MAX_ATTACHMENTS_IN_VIEW = 2;

type AttachmentsLinkViewVisitor = <ACCEPT>(view: {
   without: () => ACCEPT;
   withRemoved: (count: number) => ACCEPT;
   withAvailable: (attachments: MedicalInformationAttachment[], restAvailableCount: number) => ACCEPT;
   withAvailableAndRemoved: (
      attachments: MedicalInformationAttachment[],
      restAvailableCount: number,
      restRemovedCount: number
   ) => ACCEPT;
}) => ACCEPT;

export const attachmentsLinkViewVisitor = (attachments: MedicalInformationAttachment[]): AttachmentsLinkViewVisitor => (
   visitor
) => {
   if (isEmpty(attachments)) {
      return visitor.without();
   }

   const [availableAttachments, removedAttachments] = partition(attachments, ({ removed }) => !removed);

   if (isEmpty(availableAttachments)) {
      return visitor.withRemoved(removedAttachments.length);
   }

   const restAvailableCount = Math.max(0, availableAttachments.length - MAX_ATTACHMENTS_IN_VIEW);

   if (isEmpty(removedAttachments)) {
      return visitor.withAvailable(availableAttachments.slice(0, MAX_ATTACHMENTS_IN_VIEW), restAvailableCount);
   }

   return visitor.withAvailableAndRemoved(
      availableAttachments.slice(0, MAX_ATTACHMENTS_IN_VIEW),
      restAvailableCount,
      removedAttachments.length
   );
};

export const mapPatientConsentDocumentAttachmentsToMedicalInformationAttachments = (
   attachments: PatientConsentDocumentAttachment[]
): MedicalInformationAttachment[] => {
   return attachments.map((attachment) => ({
      id: attachment.id,
      name: attachment.name,
      downloadUrl: attachment.downloadUrl,
      editable: false,
      removed: false,
   }));
};
